import React from "react"
import { graphql,useStaticQuery } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Products from '../components/products/Products'
import TransitionLink from "gatsby-plugin-transition-link"
import {exitAnimation,entryAnimation} from '../utils/animation';
import '../styles/index.scss'

const IndexPage = () => {
  const { site,allStripeProduct } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            description
          }
        }
        allStripeProduct {
            nodes {
                name
                metadata {
                    category
                }
            }
        }
      }
    `
  )
  let categories = []
  allStripeProduct.nodes.forEach(item => {
    if (item.metadata.category) {
        let url = item.metadata.category.toLowerCase().replace(/ /g,"-")
        if (!categories[url]) {
            categories[url] = item.metadata.category
        }
    }
  })
  return (
    <Layout>
      <SEO title="Home" />
      <h1 style={{
        textAlign: 'center'
      }}>{site.siteMetadata.description}</h1>
      <nav>
        <span>CATEGORIES</span>
        {Object.entries(categories).map(([url,title]) => (
          <TransitionLink to={`category/${url}`}
            exit={{
              trigger: ({exit, node}) => exitAnimation(exit,node),
              length: 1
            }}
            entry={{
              trigger: ({entry,node}) => entryAnimation(entry,node),
              length: 1,
              delay: 1
            }}
          >{title}</TransitionLink>
        ))}
      </nav>
      <Products />
    </Layout>
  )
}

export default IndexPage
